import React from 'react'
import { UserService } from '../services/UserService';

const AuthContext = React.createContext()


class AuthProvider extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            isAuth: false,
            checkAuth: false,
            returnPath: {
                params: {},
                path: null
            }

        }
        this.loginHandler = this.loginHandler.bind(this)
        this.logoutHandler = this.logoutHandler.bind(this)
        this.setUnAuthroizedOperation = this.setUnAuthroizedOperation.bind(this);
        this.clearReturnPath = this.clearReturnPath.bind(this);
    }
    componentWillMount() {
        if (this.state.checkAuth === false) {
            UserService.Authenticated().then((response) => {
                this.setState({ isAuth: response, checkAuth: true });
            });
        }
    }
    loginHandler(data, loadingHandler, event) {

        loadingHandler(true);
        UserService.Login(data).then((response) => {

            if (response && response.token) {
                localStorage.removeItem('user');
                localStorage.removeItem('userActiveAccount');

                localStorage.setItem('user', JSON.stringify(response));

                this.setState({ isAuth: true, checkAuth: true }, () => loadingHandler(false,true));
            } else {

                this.setState({ isAuth: false, checkAuth: true }, () => loadingHandler(false,false));
            }
        });

        if (event)
            event.preventDefault();
    }

    logoutHandler(event) {

        UserService.Logout();

        this.setState({ isAuth: false });

        event.preventDefault();
    }
    setUnAuthroizedOperation(path, params) {
        this.setState({
            returnPath: {
                path: path,
                params: params
            }
        })
    }
    clearReturnPath() {
        this.setState({
            returnPath: {
                path: "",
                params: {}
            }
        })
    }

    render() {
        return (
            <AuthContext.Provider
                value={{
                    isAuth: this.state.isAuth,
                    checkAuth: this.state.checkAuth,
                    loginHandler: this.loginHandler,
                    logoutHandler: this.logoutHandler,
                    returnPath: this.state.returnPath,
                    setUnAuthroizedOperation: this.setUnAuthroizedOperation,
                    clearReturnPath: this.clearReturnPath
                }}
            >
                {this.props.children}
            </AuthContext.Provider>
        )
    }

}

const AuthConsumer = AuthContext.Consumer

export { AuthProvider, AuthConsumer }